import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { PageShell } from "@/components/layout/PageShell";
import { NotificationsPanel } from "@/features/notifications/NotificationsPanel";
import { SettingsScreen } from "@/features/settings/SettingsScreen";
import { AccountScreen } from "@/features/account/AccountScreen";
import { HomeScreen } from "@/features/chat/HomeScreen";
import { ChatScreen } from "@/features/chat/ChatScreen";
import { PodListScreen } from "@/features/pods/PodListScreen";
import { PodDetailScreen } from "@/features/pods/PodDetailScreen";
import { NotFound } from "@/app/NotFound";

/**
 * FullCalendar and its three plugins are far larger than the rest of the app put together, and
 * only this one route needs them. Lazily loading the screen keeps them out of the bundle every
 * other screen pays for.
 */
const CalendarScreen = lazy(() =>
  import("@/features/calendar/CalendarScreen").then((module) => ({
    default: module.CalendarScreen,
  })),
);

/**
 * Every route in the app.
 *
 * Only routes whose feature actually exists are listed: a new screen adds its entry here and, if
 * it belongs in the chrome, a matching one in `navigation.ts`. A route to a placeholder is
 * indistinguishable from a broken one.
 */
export function AppRoutes() {
  return (
    <PageShell>
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/chat" element={<ChatScreen />} />
        {/* gaia-app put the list at /dashboard. /pods reads better beside /pods/:id, and there
            is no deployed URL to keep working. */}
        <Route path="/pods" element={<PodListScreen />} />
        <Route path="/pods/:id" element={<PodDetailScreen />} />
        <Route
          path="/calendar"
          element={
            <Suspense fallback={<p className="p-8 text-sm text-text-muted">Loading calendar…</p>}>
              <CalendarScreen />
            </Suspense>
          }
        />
        <Route path="/notifications" element={<NotificationsPanel />} />
        <Route path="/settings" element={<SettingsScreen />} />
        <Route path="/account" element={<AccountScreen />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </PageShell>
  );
}
